import { lazy } from 'react';

const show = lazy(() => import('./Show'));

export default {
  show,
};
